import React from "react";
import { TableCell, TableRow } from "@mui/material";

import BoxGrid from "../boxGrid/boxGrid";

import * as S from "./styles";
import { ParameterTypesResponse, Parameters } from "@/main/models/response/parameterTypesResponse";
import ParameterTypeValueComponent from "../parameterTypeValueComponent/parameterTypeValueComponent";

type IOptionsId = "parameterName" | "description" | "value";
interface IOptionElement {
	typeColumn: IOptionsId;
	content: string | string[] | ParameterTypesResponse;
	width?: string | number;
	valueParameterAPI?: ParameterTypesResponse;
}

export type IOptionGridMultiline = {
	id: string | number;
	elements: IOptionElement[];
};

interface IKogBoxGridMultiline {
	rowHeaders: string[] | React.ReactNode[];
	options: IOptionGridMultiline[];
	handleValue: (idParameterTypeRow: number, id: string, newValue: string | null) => void;
	onClickCustom?: (option: IOptionGridMultiline, event: React.MouseEvent<HTMLTableRowElement, MouseEvent>) => void;
	typeGrid?: "oddEven" | "default" | "backgroundHeader";
	sizeCell?: "small" | "medium" | "large";
}

function KogBoxGridParameter({
	options,
	rowHeaders,
	onClickCustom = () => {},
	handleValue,
	typeGrid = "default",
	sizeCell = "large",
}: IKogBoxGridMultiline) {
	let indexRenderParameterField: number = 0;

	const RenderContent = ({ optionElement, indexColumn }: { optionElement: IOptionElement; indexColumn: number }) => {
		const RenderString = ({ content }: { content: string | string[] }): JSX.Element =>
			Array.isArray(content) ? (
				<>
					{content.map((item, index) => (
						<S.ItemGrid key={`indexElement-${indexColumn}-${index}`} sizeCell={sizeCell}>
							{item}
						</S.ItemGrid>
					))}
				</>
			) : (
				<S.ItemGrid sizeCell={sizeCell}>{content}</S.ItemGrid>
			);
		const RenderParameterField = ({
			content,
			valueParameterAPI,
		}: {
			content: ParameterTypesResponse;
			valueParameterAPI?: ParameterTypesResponse;
		}): JSX.Element => {
			return (
				<>
					{content.parameters.map((parameter: Parameters) => {
						indexRenderParameterField++;
						return (
							<S.ItemGrid sizeCell={sizeCell} key={parameter.guid}>
								<S.TextValue cursor="pointer" textUnderline id={`id-register-parameters-${indexRenderParameterField}`}>
									<ParameterTypeValueComponent
										idParameterTypeRow={content.idParameterType}
										id={parameter.guid}
										maxAcceptValue={content.maxAcceptValue}
										value={parameter.value}
										typeValue={content.idParameterTypeValue}
										handleValue={handleValue}
										oldValue={
											valueParameterAPI?.parameters.find((parameterAPI) => parameterAPI.guid === parameter.guid)?.value
										}
									/>
								</S.TextValue>
							</S.ItemGrid>
						);
					})}
				</>
			);
		};
		const objRender: Record<IOptionsId, JSX.Element> = {
			parameterName: <RenderString content={optionElement.content as string | string[]} />,
			description: <RenderString content={optionElement.content as string | string[]} />,
			value: (
				<RenderParameterField
					content={optionElement.content as ParameterTypesResponse}
					valueParameterAPI={optionElement.valueParameterAPI}
				/>
			),
		};

		return objRender[optionElement.typeColumn] ?? <></>;
	};

	return (
		<S.StyledBoxGrid>
			<BoxGrid typeGrid={typeGrid} sizeCell={sizeCell} rowHeaders={rowHeaders}>
				{options.map((option) => (
					<TableRow key={option.id} onClick={(e) => onClickCustom(option, e)}>
						{option.elements.map((item, index) => (
							<TableCell key={`${option.id}-${index}`} width={item.width}>
								<S.BaseTableCellGridMultiline>
									<RenderContent optionElement={item} indexColumn={index} />
								</S.BaseTableCellGridMultiline>
							</TableCell>
						))}
					</TableRow>
				))}
			</BoxGrid>
		</S.StyledBoxGrid>
	);
}

export default KogBoxGridParameter;
